/**
 * Раскладка оболочки: телефон, узкий экран, стойка.
 *
 * ПОЧЕМУ РАСКЛАДКУ ВЫБИРАЕТ ШИРИНА, А НЕ РОЛЬ. В макете три роли нарисованы на трёх разных
 * ширинах, и соблазн написать «мастер → телефон, владелец → иконки» велик. Он неверен:
 * администратор открывает кабинет с телефона по дороге на работу, мастер смотрит свой день
 * на планшете в подсобке, а владелец сети садится за монитор 1440. Раскладка, привязанная
 * к роли, выдала бы мастеру двумерную сетку на 360 точках — ровно то, что ТЗ §7.2 запрещает.
 *
 * Роль решает ДРУГОЕ и решает по-прежнему: какие разделы вообще есть в навигации (права),
 * есть ли переключатель филиалов (сеть) и можно ли выбрать «Все филиалы» (раздел).
 *
 * ПОЧЕМУ ТРИ, А НЕ ОДНА РАСТЯНУТАЯ СЕТКА (ТЗ §7). Телефон и ноутбук — разные задачи:
 * «один экран — один ответ» против «день, клиент и карточка одновременно». Между ними
 * лежит третья, настоящая ширина 1024 — старый монитор у стойки и окно браузера
 * на половину экрана; там боковая навигация 200px съедает пятую часть рабочей области,
 * поэтому она сжимается до иконочной полосы 56px, а не исчезает.
 */

export type ShellLayout =
  /** 360–767: нижние вкладки, сетка журнала превращается в список. */
  | "phone"
  /** 768–1199: иконочная навигация 56px. Ориентир макета — владелец сети на 1024. */
  | "compact"
  /** 1200 и шире: боковая навигация 200px. Ориентиры макета — 1366×768 и 1440+. */
  | "desktop"

/** Верхняя граница телефона. 768 — первая ширина, на которой сетка дня ещё читается. */
export const PHONE_MAX_WIDTH = 767

/** Верхняя граница узкого экрана. 1200 — ширина, начиная с которой 200px навигации не жаль. */
export const COMPACT_MAX_WIDTH = 1199

/**
 * Ширина, от имени которой рисуется первый кадр там, где окна ещё нет (проверки, разбор
 * разметки на сервере). Взята контрольная ширина стойки из ТЗ, а не телефон: ошибиться
 * в сторону просторной раскладки дешевле — она переживает сужение, обратное неверно.
 */
export const REFERENCE_WIDTH = 1366

export function resolveLayout(width: number): ShellLayout {
  if (width <= PHONE_MAX_WIDTH) return "phone"
  if (width <= COMPACT_MAX_WIDTH) return "compact"
  return "desktop"
}

/** Навигация занимает место сбоку: на телефоне её там нет, она внизу вкладками. */
export function hasSideNav(layout: ShellLayout): boolean {
  return layout !== "phone"
}
